export default __webpack_public_path__ + "static/media/agriPrototype.d59d2fed.png";